import { render, staticRenderFns } from "./deleteMenuGroup.vue?vue&type=template&id=5a848f7c"
import script from "./deleteMenuGroup.vue?vue&type=script&lang=js"
export * from "./deleteMenuGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports